export default __webpack_public_path__ + "static/media/Hood of Endless Night.5f6327bc.jpg";